module.exports = __webpack_public_path__ + "static/media/Decisions_Step4_Image21.64f34421.jpg";